const InfoButton = ({ onClick }) => {

  return (
    <button className="info-button" onClick={onClick}>
      ?
    </button>
  );
};

export default InfoButton;